import React, { createContext, useState } from "react";
import _ from "lodash";

const initialState = {
  requestId: "",
  jobs: [],
  recordId: "",
  total: -1,
  mode: "",
  status: "",
  isDraft: false,
  jobData: [],
};

export const TableViewSelectionContext = createContext({
  selected: initialState,
  upadateSelection: (_data) => {},
  reset: () => {},
});

export const TableViewSelectionContextProvider = ({ children }) => {
  const [selected, setselected] = useState(initialState);

  const upadateSelection = (data) => {
    const previousWorkOrderId = _.get(selected, "requestId");
    const currentWorkOrderId = _.get(data, "requestId");

    const currentJob = _.get(data, "job");
    const currentRecordId = _.get(data, "recordId");
    const isDraft = _.get(data, "isDraft");
    const total = _.get(data, "total");
    const previousJobs = _.get(selected, "jobs", []);
    const mode = _.get(data, "mode");
    const status = _.get(data, "status");
    const jobData = _.get(data, "jobData");
    const previousJobData = _.get(selected, "jobData", []);

    if (mode === "request") {
      if (_.isEmpty(previousWorkOrderId)) {
        setselected({
          ...selected,
          requestId: currentWorkOrderId,
          jobs: [currentJob],
          recordId: currentRecordId,
          total: total,
          mode: mode,
          status: status,
          isDraft: isDraft,
          jobData: [jobData],
        });
      } else {
        if (previousWorkOrderId === currentWorkOrderId) {
          if (_.includes(previousJobs, currentJob)) {
            const updatedJobsArray = _.filter(
              previousJobs,
              (job) => job !== currentJob
            );
            const updatejobData = _.filter(
              previousJobData,
              (job) => job !== jobData
            );
            if (_.size(updatedJobsArray) > 0) {
              setselected({
                ...selected,
                jobs: updatedJobsArray,
                jobData: updatejobData,
              });
            } else {
              setselected(initialState);
            }
          } else {
            selected.jobs.push(currentJob);
            selected.jobData.push(jobData);
            setselected({
              ...selected,
              jobs: selected.jobs,
              jobData: selected.jobData,
            });
          }
        } else {
          setselected({
            ...selected,
            requestId: currentWorkOrderId,
            jobs: [currentJob],
            recordId: currentRecordId,
            total: total,
            mode: mode,
            isDraft: isDraft,
            status: status,
            jobData: [jobData],
          });
        }
      }
    } else if (mode === "job") {
      if (_.isEmpty(previousWorkOrderId)) {
        setselected({
          ...selected,
          requestId: currentWorkOrderId,
          jobs: currentJob ? [currentJob] : selected.jobs,
          total: total,
          mode: mode,
          recordId: currentRecordId,
          status: status,
          isDraft: isDraft,
          jobData: [jobData],
        });
      } else {
        if (JSON.stringify(selected.jobs) === JSON.stringify([currentJob])) {
          setselected(initialState);
        } else {
          setselected({
            ...selected,
            requestId: currentWorkOrderId,
            jobs: currentJob ? [currentJob] : selected.jobs,
            total: total,
            mode: mode,
            recordId: currentRecordId,
            status: status,
            isDraft: isDraft,
            jobData: [jobData],
          });
        }
      }
    } else if(mode === "requestSummary"){
      setselected({
        requestId: currentWorkOrderId,
        jobs: [],
        total: total,
        mode: mode,
        recordId: currentRecordId,
        status: status,
        isDraft: isDraft,
        jobData: jobData,
      });
    } else{
      // Don't update selection
    }
  };

  const reset = () => {
    setselected(initialState);    
  };

  return (
    <TableViewSelectionContext.Provider
      value={{ selected, upadateSelection, reset }}
    >
      {children}
    </TableViewSelectionContext.Provider>
  );
};
